import React from "react";
import { createStackNavigator } from "@react-navigation/stack";
import LoginScreen from "../screens/LoginScreen";
import RegisterScreen from "../screens/RegisterScreen";
import HomeScreen from "../screens/HomeScreen/HomeScreen";
import PaymentScreen from "../screens/PaymentScreen";
import ChangePasswordScreen from "../screens/ChangePasswordScreen";
import useAuth from "../hooks/useAuth";
import StackScreenList, { ScreenListNames } from "./StackScreenList";
import LoadingScreen from "../screens/LoadingScreen";
import ResetPasswordScreen from "../screens/ResetPasswordScreen";

export const linkingConfig: { [key in ScreenListNames]: string } = {
    LoginScreen: "login",
    RegisterScreen: "register",
    HomeScreen: "",
    PaymentScreen: "payment",
    ChangePasswordScreen: "change-password",
    ResetPasswordScreen: "reset-password",
};

const Stack = createStackNavigator<StackScreenList>();

const AppNavigator: React.FC = () => {
    const { user, isLoading } = useAuth();

    if (isLoading) {
        return <LoadingScreen />;
    }

    return (
        <Stack.Navigator screenOptions={{ headerShown: false }}>
            {!user ? (
                <>
                    <Stack.Screen name="LoginScreen" component={LoginScreen} />
                    <Stack.Screen
                        name="RegisterScreen"
                        component={RegisterScreen}
                    />
                    <Stack.Screen
                        name="ResetPasswordScreen"
                        component={ResetPasswordScreen}
                    />
                </>
            ) : (
                <>
                    <Stack.Screen name="HomeScreen" component={HomeScreen} />
                    <Stack.Screen
                        name="PaymentScreen"
                        component={PaymentScreen}
                    />
                    <Stack.Screen
                        name="ChangePasswordScreen"
                        component={ChangePasswordScreen}
                    />
                </>
            )}
        </Stack.Navigator>
    );
};

export default AppNavigator;
